module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-course-meal-ae860790439937041b1c71d36297c2b7.png";